import { useMemo } from 'react';

import { getLocalStorage } from '@libs/storage';
import { generateUUID } from '@libs/uuid';

const STORAGE_KEY = 'anon_secret';
const MIN_LENGTH = 30;

export function useAnonymousSecret(isAuthenticated: boolean): string | null {
  return useMemo(() => {
    if (isAuthenticated) return null;

    const storage = getLocalStorage();
    let secret = storage.getItem(STORAGE_KEY);

    if (!secret || secret.length < MIN_LENGTH) {
      secret = generateUUID();
      storage.setItem(STORAGE_KEY, secret);
    }

    return secret;
  }, [isAuthenticated]);
}
